<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.06 67.06">
  <path
    d="M14.2 35.61c-1.25,-1.25 -1.25,-3.28 0,-4.53 1.25,-1.25 3.28,-1.25 4.53,0l8.79 8.79 20.8 -20.8c1.25,-1.25 3.28,-1.25 4.53,0 1.25,1.25 1.25,3.28 0,4.53l-25.33 25.33 -13.32 -13.32z"/>
</svg>
